<script setup>
import { ref, onMounted } from 'vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import MainSideBar from '@/components/MainSideBar.vue'

import { useAccount } from '@/stores/account'
import { useAuth } from '@/stores/auth'

onMounted(async () => {
  loadRequiredData()
})

const auth = useAuth()
const account = useAccount()

const openSideBar = ref(false)

async function toggleSideBar(value) {
  openSideBar.value = value
}

async function loadRequiredData() {
  if (!auth.id) return
  try {
    await account.get(auth.id)
  } catch {
    auth.logout()
  }
}

const favicon = document.getElementById('favicon')
if (favicon) {
  favicon.href = '/favicon.png'
}
</script>

<template>
  <div>
    <div class="hidden xl:fixed xl:inset-y-0 xl:z-40 xl:flex xl:w-72 xl:flex-col">
      <MainSideBar :show-side-bar="openSideBar" @toggle="toggleSideBar" />
    </div>

    <div class="xl:pl-72">
      <!-- Mobile-only header with hamburger -->
      <div class="sticky top-0 z-40 flex h-14 shrink-0 items-center px-4 bg-white/80 backdrop-blur-sm border-b border-gray-100 xl:hidden">
        <button type="button" class="-m-2.5 p-2.5 text-gray-700" @click="openSideBar = true">
          <span class="sr-only">Open sidebar</span>
          <Bars3Icon class="h-6 w-6" aria-hidden="true" />
        </button>
        <img class="h-7 w-auto ml-3" src="/src/assets/img/logo-light.png" alt="Emailpref" />
      </div>

      <main class="min-h-screen bg-gray-50">
        <div>
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>
